export const FETCH_MAP_INTERCOMS_REQUEST = 'maps/FETCH_INTERCOMS_REQUEST'
export const FETCH_MAP_INTERCOMS_FAILURE = 'maps/FETCH_INTERCOMS_FAILURE'
export const FETCH_MAP_INTERCOMS_SUCCESS = 'maps/FETCH_INTERCOMS_SUCCESS'
